<template>
  <v-app-bar :height="heightBar" color="#fff" flat app>
    <v-container class="pa-0 px-md-3 py-lg-3 fill-height">
      <v-img
        class="mx-0 mx-md-2"
        src="@/assets/img/logo.svg"
        max-height="38"
        max-width="120"
        contain
        style="cursor: pointer"
        @click="$router.push({ name: 'Documents' }).catch(() => {})"
      />
      <v-spacer />

      <div v-if="$auth.check()">
        <v-btn
          class="mr-2"
          small
          depressed
          @click="$router.push({ name: 'Documents' }).catch(() => {})"
        >
          Мои документы
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              v-bind="attrs"
              v-on="on"
              class="hidden-xs-only"
            >
              <v-icon left> mdi-account </v-icon>
              +7{{ $auth.user().phone }}
            </v-btn>
            <v-btn icon small v-bind="attrs" v-on="on" class="hidden-sm-and-up">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout()">
              <v-list-item-title>Выйти</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <template v-else>
        <v-btn dark @click="$store.state.loginPopup = !$store.state.loginPopup">
          Войти без регистрации
        </v-btn>
      </template>
    </v-container>
    <v-dialog v-model="$store.state.loginPopup" persistent max-width="480">
      <v-card>
        <v-card-title class="headline d-flex justify-space-between">
          <span class="text-h4">Авторизация</span>
          <v-btn
            class="d-flex justify-end pa-0"
            color="primary"
            text
            @click="
              $store.state.loginPopup = !$store.state.loginPopup;
              form.response.message = form.response.status = null;
            "
          >
            <v-icon size="32"> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="loginForm" class="pa-6 pt-1" @submit.prevent="submit()">
          <v-text-field
            v-model="form.phone"
            v-mask="'+7 ### ###-##-##'"
            label="Телефон"
            placeholder="+7"
            required
            :disabled="form.status"
            :rules="[rules.required, rules.phone]"
          />
          <v-text-field
            v-if="form.status"
            v-model="form.code"
            type="text"
            label="Код подтверждения"
            required
            :rules="[rules.required, rules.code]"
            @keydown.enter.prevent="submit()"
            autofocus
          />
          <v-subheader
            v-if="
              form.countdown > 0 &&
              form.status &&
              form.response.status != 'success'
            "
            class="pa-0 pb-3"
          >
            Повторить отправку через {{ form.countdown }} секунд
          </v-subheader>
          <v-alert v-if="form.response.message" :type="form.response.status">
            {{ form.response.message }}
          </v-alert>
          <a
            v-else-if="
              form.countdown <= 0 &&
              form.status &&
              form.response.status != 'success'
            "
            class="d-block"
            href="javascript:;"
            @click="form.status = false"
            >Повторить отправку СМС
          </a>
          <v-btn
            v-if="!form.status"
            color="accent"
            class="mt-4 mr-4 text--primary"
            @click="getCode()"
          >
            Получить пароль по СМС
          </v-btn>
          <v-btn
            v-if="form.response.status != 'success' && form.status"
            color="accent"
            class="mt-4 mr-4 text--primary"
            @click="login()"
          >
            Войти
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
export default {
  name: "TopMenu",
  props: ["value"],
  data() {
    return {
      form: {
        phone: null,
        code: null,
        response: {
          status: null,
          message: null,
        },
        countdown: 0,
        status: false,
      },
      rules: {
        required: (v) =>
          (v && v.trim() !== "") || "Это поле обязательно для заполнения",
        phone: (v) =>
          /\+7 ([0-9]{3}) ([0-9]{3})-([0-9]{2})-([0-9]{2})/gi.test(v) ||
          "Некорректно введен номер телефона",
        code: (v) =>
          /([0-9]{4})/gi.test(v) || "Некорректно введен код подтверждения",
      },
    };
  },
  computed: {
    heightBar() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 60;
        case "sm":
          return 60;
        default:
          return 80;
      }
    },
  },
  mounted() {
    // var self = this
    // this.$auth.fetch().then(function () {
    //   console.log(self.$auth.user())
    // });
  },
  methods: {
    validate() {
      return this.$refs.loginForm.validate();
    },
    submit() {
      if (!this.validate()) {
        return false;
      }
      if (this.form.status) {
        this.login();
      } else {
        this.getCode();
      }
    },
    getCode() {
      if (!this.validate()) {
        return false;
      }
      var self = this;
      const options = {
        method: "post",
        headers: { "Content-Type": "application/json" },
        url: process.env.VUE_APP_API + "/auth/send",
        mode: "cors",
        data: { phone: this.form.phone },
      };
      this.axios(options)
        .then(() => {
          self.form.response.status = self.form.response.message = null;
          self.form.status = true;
          self.form.countdown = 59;
          let timer = setInterval(function () {
            if (self.form.countdown > 0) {
              self.form.countdown--;
            } else {
              clearInterval(timer);
            }
          }, 1000);
        })
        .catch(function (error) {
          if (error.response.data) {
            self.form.response = error.response.data;
          }
          console.log(error);
        });
    },
    logout() {
      this.$auth.logout({
        makeRequest: true,
        redirect: false,
      });
      this.$store.commit("unsetUser");
      this.form.login = null;
      this.form.code = null;
      this.form.status = false;
      this.form.response.status = null;
      this.form.response.message = null;
    },
    login() {
      var self = this;
      this.$auth
        .login({
          data: { phone: this.form.phone, code: this.form.code },
          staySignedIn: true,
          fetchUser: true,
          rememberMe: true,
          redirect: false,
        })
        .then(() => {
          self.form.response.message = "Успешный вход";
          self.form.response.status = "success";
          setTimeout(function () {
            self.$store.state.loginPopup = !self.$store.state.loginPopup;
            self.form.response.message = self.form.response.status = null;
          }, 2000);
          if (window.dataLayer !== undefined) {
            window.dataLayer.push({ event: "userLogin" });
          }
        })
        .catch(function (error) {
          if (error.response) {
            self.form.response = error.response.data;
          }
        });
    },
  },
};
</script>
